import dayjs from 'dayjs';
import localData from 'dayjs/plugin/localeData';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';

/**
 * check if date value is after now
 * @param {mixed} d date value. object or string
 * @returns {boolean}
 */
const isDateAfterNow = (d) => ((d) ? dayjs(d).isAfter(dayjs()) : false);

/**
 * format date into string
 * @param {mixed} d date value. object or string
 * @param {boolean} withTime includes time in result
 * @returns {string}
 */
const formatDateToString = (d = '', withTime = false) => {
  if (!d) return '';
  dayjs.extend(localData);
  let format = 'DD/MM/YYYY';
  if (withTime) {
    format += ', HH:mm';
  }

  const formatted = dayjs(d).format(format);

  return formatted;
};

const formatDate = (d = new Date()) => d.toLocaleDateString('en-GB');

dayjs.extend(customParseFormat);
dayjs.extend(utc);
const isValidDate = (val) => dayjs(val, 'DD/MM/YYYY', true).isValid();

const stringToDate = (val = '') => {
  try {
    return isValidDate(val)
      ? dayjs(val, 'DD/MM/YYYY', true).toDate() // Enforcing strict parsing
      : null;
  } catch (err) {
    return null;
  }
};

function formatDateToDDMMYYYY(dateString) {
  const date = new Date(dateString);

  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-indexed
  const year = date.getUTCFullYear();

  return `${day}/${month}/${year}`;
}

const yearsToMonths = (years) => years * 12;

export const toISOString = (val) => {
  if (!val) return null;

  const parsed = dayjs(val, 'DD/MM/YYYY, HH:mm', true).isValid()
    ? dayjs(val, 'DD/MM/YYYY, HH:mm', true)
    : dayjs(val, 'DD/MM/YYYY', true);

  if (!parsed.isValid()) return null;

  const hasTime = /,?\s*\d{2}:\d{2}$/.test(val);
  const normalized = hasTime ? parsed : parsed.startOf('day');

  return normalized.utc().toISOString();
};

export {
  isDateAfterNow,
  formatDateToString,
  formatDate,
  formatDateToDDMMYYYY,
  stringToDate,
  yearsToMonths,
};
